/**
 * @author: Wangwei
 * @description: 打卡营招生页
 */
import styles from './css/enrollStudentxPageCSS.less';
import { useRequest, useParams, Helmet, useModel, useLocation } from 'umi';
import { useState, useEffect, useRef } from 'react';
import cx from 'classnames';
import { Button, Tooltip, Modal } from 'antd';
import ReactSeamlessScroll, { SeamlessScrollProps } from 'rc-seamless-scroll';
import DynamicTabs from './components/dynamic/dynamicTabs';
import { studentBaseInfo } from '@/utils/requests/camp/requests_study';
import { getRecruitStudents } from '@/utils/requests/camp/requests_index';
import { StudyInfoType } from '@/types/camp/study/studentBaseInfoType';
import { getShowLogAll } from '@/utils/requests/camp/requests_details';
import { showLogType } from '@/types/camp/details/showLogType';
import EntryFormModal from '@/pages/EntryFormModal';
import { PageCampVO, PromotionalImage, Batch } from '@/types/camp/campIndex/indexTypes';
import DateFormat from '@/components/dateFormat';
import { CampStudyState } from '@/types/camp/study';
import { loginCas } from '@/utils';
import EventTracking from '@/pages/camp/components/tracking/EventTracking';
import { InfoCircleOutlined } from '@ant-design/icons';
import { getParame } from '@/pages/camp/util/indexUtil';

export default function recruitStudents() {
  const { id: campId } = useParams() as { id: string };
  const [batchId, setBatchId] = useState<string>();
  const [newTitle, setNewTitle] = useState<string>();
  const [open, setOpen] = useState<boolean>(false);
  const [loglistData, setLogListData] = useState<[showLogType] | null>(null);
  const [campData, setCampData] = useState<PageCampVO>();
  const [entryBatch, setEntryBatch] = useState<Batch>();
  const [studentInfo, setStudentInfo] = useState<StudyInfoType | null>(null);
  const [isStudentInfo, setIsStudentInfo] = useState<boolean>(false);
  const { initialState } = useModel('@@initialState');
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const entryForm = queryParams.get('entryForm');
  const isPC = document.body.clientWidth > 1200;
  const myDivRef = useRef<HTMLDivElement>(null);
  const [loadBatch, setLoadBatch] = useState<boolean>(false);
  const classBatchId = getParame('class');

  // 获取招生页数据
  const { run: getRecruitStudentsRequest } = useRequest(
    () => {
      return getRecruitStudents(campId, classBatchId || undefined);
    },
    {
      manual: true,
      onSuccess: (res: PageCampVO) => {
        setCampData(res);
        setNewTitle(res.name);
        if (res.signUp && res.campStudyState !== CampStudyState.CAMP_FAIL) {
          // 已报名且学习中
          setBatchId(res.batchInfo.id);
        } else if (res.signUp && classBatchId) {
          // 打卡失败且指定了批次
          setBatchId(res.batchInfo.id);
        } else if (
          res.signUp &&
          !res.nextBatchInfo &&
          res.campStudyState == CampStudyState.CAMP_FAIL
        ) {
          // 打卡失败且没有可报名的批次
          setBatchId(res.batchInfo.id);
        } else {
          setIsStudentInfo(true);
        }
        // 设置报名批次
        if (res.nextBatchInfo && res.campStudyState == CampStudyState.CAMP_FAIL) {
          // 打卡失败且有可报名的批次
          setEntryBatch(res.nextBatchInfo);
        } else {
          // 正常情况下可报名批次
          setEntryBatch(res.batchInfo);
        }
      },
    },
  );

  useEffect(() => {
    if (entryForm === 'true') {
      setOpen(true);
    }
  }, [entryForm]);

  useEffect(() => {
    if (campData?.recruitPage?.dynamicCommunication?.dynamicCommunication) {
      let imgList = Array.isArray(campData?.recruitPage.promotionalImages)
        ? campData.recruitPage.promotionalImages
        : [];

      let dynamic: PromotionalImage = {
        index: campData.recruitPage.dynamicCommunication?.index,
        dynamic: campData.recruitPage.dynamicCommunication.dynamicCommunication,
      };

      if (dynamic.index !== undefined) {
        imgList.push(dynamic);
        imgList.sort(function (a, b) {
          return a.index - b.index;
        });
      }
    }
  }, [campData]);

  // 获取展示打卡记录
  const { run: getShowLogRequest } = useRequest(
    () => {
      return getShowLogAll(campId);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setLogListData(res);
      },
    },
  );

  useEffect(() => {
    getRecruitStudentsRequest();
    getShowLogRequest();
  }, []);

  // 获取学习节点基础信息
  const { run: studentBaseInfoRequest } = useRequest(
    (batchId) => {
      return studentBaseInfo(batchId);
    },
    {
      manual: true,
      onSuccess: (res) => {
        // console.log('studentInfo', res);
        setStudentInfo(res);
        setIsStudentInfo(true);
      },
    },
  );

  useEffect(() => {
    batchId && studentBaseInfoRequest(batchId);
  }, [batchId]);

  // 底部悬浮
  const [isScrollTop, setIsScrollTopNum] = useState(false);
  const [isShowScroll, setIsShowScroll] = useState(false);
  const getPageScrollTop = () => {
    window.addEventListener('scroll', function () {
      let scrollTopValue = document.documentElement.scrollTop || document.body.scrollTop;
      scrollTopValue > 300 ? setIsScrollTopNum(true) : setIsScrollTopNum(false);
    });
  };

  useEffect(() => {
    getPageScrollTop();
    let timerId = setTimeout(function () {
      setLoadBatch(true);
      if (myDivRef.current) {
        const height = myDivRef.current.offsetHeight;
        if (height > 700) {
          setIsShowScroll(true);
        }
      }
    }, 500);
    return () => {
      clearTimeout(timerId);
    };
  }, []);

  return (
    <>
      <div className={styles.enrollStudentx_banner}>
        {newTitle && (
          <Helmet>
            <title>{`${newTitle}- 打卡营 - 帆软学院`}</title>
          </Helmet>
        )}

        <div className={cx(styles.banner_warp, 'w1200 flex_3')}>
          <div className={cx(styles.lf, 'flex_2')}>
            <div className={styles.title}>{campData?.name}</div>
            {isPC ? (
              <div className={cx(styles.info, 'f14 col5a5 hide_txt2')}>
                {campData?.info && campData?.info.length > 100 ? (
                  <Tooltip
                    overlayStyle={{ maxWidth: 500 }}
                    title={<div style={{ padding: 4 }}>{campData?.info}</div>}
                  >
                    <div style={{ maxHeight: 40 }}>{campData?.info}</div>
                  </Tooltip>
                ) : (
                  <div>{campData?.info}</div>
                )}
              </div>
            ) : (
              <div className={cx(styles.info, 'f14 col5a5 hide_txt3')}>
                {campData?.info && campData?.info.length > 100 ? (
                  <Tooltip
                    overlayStyle={{ maxWidth: '90%' }}
                    title={<div style={{ padding: 4 }}>{campData?.info}</div>}
                  >
                    <div style={{ maxHeight: 56 }}>{campData?.info}</div>
                  </Tooltip>
                ) : (
                  <div>{campData?.info}</div>
                )}
              </div>
            )}

            <div className={cx(styles.banner_btn_box, 'flex_1')} style={{ gap: 16 }}>
              {campData?.batchInfo && (
                <div className={styles.details_btn_box_main}>
                  {studentInfo ? (
                    <div className={cx(styles.details_btn_box, 'flex_1')}>
                      <a
                        className={cx(styles.details_btn, 'com_camp_btn')}
                        href={`/v2/camp/class/${studentInfo.batchId}`}
                      >
                        进入打卡营
                      </a>
                      <div className={styles.details_time}>
                        {studentInfo?.campStudyState === CampStudyState.STUDYING && (
                          <div style={{ marginLeft: 16 }}>
                            <DateFormat endTime={campData?.batchInfo.enTime} endText="后结束" />
                          </div>
                        )}
                        {studentInfo?.campStudyState === CampStudyState.NOT_START_LEARNING && (
                          <div style={{ marginLeft: 16 }}>
                            <DateFormat endTime={campData?.batchInfo.stTime} endText="后开始" />
                          </div>
                        )}
                      </div>
                    </div>
                  ) : !campData?.signUp ? (
                    <div className={cx(styles.details_btn_box, 'flex_1')}>
                      <a
                        className={cx(styles.details_btn, 'com_camp_btn_orange')}
                        onClick={() => {
                          // 判断是否登录
                          if (!initialState?.uid) {
                            loginCas({
                              env: process.env.UMI_ENV === 'product' ? 'prod' : 'test',
                              redirectUrl: location.search
                                ? `${location.pathname}${location.search}&entryForm=true`
                                : `${location.pathname}?entryForm=true`,
                            });
                          } else {
                            if (campData.studentCampSuccess) {
                              Modal.confirm({
                                icon: <InfoCircleOutlined style={{ color: '#0082fc' }} />,
                                title: '已经学习过此打卡营了',
                                content: (
                                  <div>
                                    点击这里
                                    <a
                                      href={`/v2/camp/class/${campData.studentCampSuccess?.batchId}`}
                                      target="_blank"
                                      className="col008"
                                    >
                                      查看打卡成功记录
                                    </a>
                                  </div>
                                ),
                                onCancel: () => {
                                  window.location.href = '/v2/camp';
                                },
                                centered: true,
                                okText: '我知道了',
                                cancelText: '查看更多打卡营',
                                autoFocusButton: null,
                              });
                            } else {
                              setOpen(true);
                            }
                          }
                        }}
                      >
                        立即报名
                      </a>
                      <div className={styles.details_time}>
                        {entryBatch && (
                          <div style={{ marginLeft: 14 }}>
                            <DateFormat endTime={entryBatch?.stTime} startText="报名截止：" />
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <Button style={{ width: 160, height: 40 }} type="default" disabled>
                      暂无开班计划
                    </Button>
                  )}
                </div>
              )}
              {isStudentInfo && !campData?.batchInfo && (
                <Button style={{ width: 160, height: 40 }} type="default" disabled>
                  {classBatchId ? '已结束报名' : '暂无开班计划'}
                </Button>
              )}
              {initialState?.uid &&
              campData?.firstBatchInfo &&
              (initialState?.permission.superAdmin ||
                initialState?.permission.manageCamp ||
                campData.ownerId === initialState?.uid ||
                campData.administrators?.includes(initialState?.uid)) ? (
                <div className="m_dn">
                  <a
                    className="btn_fff_def wbtn160"
                    href={`/v2/camp/manage/${campData?.firstBatchInfo.id}`}
                    style={{ marginRight: 16 }}
                  >
                    打卡营管理
                  </a>
                </div>
              ) : (
                campData?.authBatchInfo && (
                  <div>
                    <a
                      className="btn_fff_def wbtn160"
                      href={`/v2/camp/manage/${campData?.authBatchInfo.id}`}
                      style={{ marginRight: 16 }}
                    >
                      打卡营管理
                    </a>
                  </div>
                )
              )}
            </div>
          </div>
          {loglistData && loglistData?.length > 0 ? (
            <div className={cx(styles.rt)}>
              <div className={styles.wheel_box}>
                <ReactSeamlessScroll<SeamlessScrollProps>
                  list={loglistData}
                  wrapperHeight={160}
                  step={0.5}
                  hover
                >
                  {loglistData.map((item, index) => (
                    <div className={styles.wheel_list_box} key={index}>
                      <span className="col808 com_ws_no">{item.username}</span>
                      <span className="col172">{item.uid ? '领取了奖励' : '完成了'}</span>
                      {item.uid ? (
                        <span className="colff3">{item.rewardName}</span>
                      ) : (
                        <span className="col008">{item.nodeName}</span>
                      )}
                    </div>
                  ))}
                </ReactSeamlessScroll>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>

      <div className="w1200 com_mt_24 com_mb_24" ref={myDivRef}>
        <div>
          {campData &&
            campData?.recruitPage &&
            campData?.recruitPage.promotionalImages.map((item, index) => (
              <div key={index}>
                {item.dynamic && (
                  <div className="com_mt_24">
                    <DynamicTabs campId={campId} type={1} selectNode={false} />
                  </div>
                )}
                <img
                  key={index}
                  src={isPC ? item.pcUrl : item.mobileUrl}
                  style={{ width: '100%', height: 'auto', display: 'block' }}
                />
              </div>
            ))}
        </div>
      </div>

      {isShowScroll && (
        <div
          className={cx(
            styles.enroll_foot_tool,
            isScrollTop ? styles.enroll_foot_tool_current : '',
            'm_dn',
          )}
        >
          <div className={cx(styles.enroll_foot_tool_info)}>
            <div className={cx(styles.banner_btn_box)}>
              {campData?.batchInfo && (
                <div className={styles.details_btn_box_main}>
                  {studentInfo ? (
                    <div className={cx(styles.details_btn_box, 'flex_3')}>
                      <div className="flex_2">
                        <div className="f20 fw600">{campData?.name}</div>
                        {studentInfo?.campStudyState === CampStudyState.STUDYING && (
                          <div className={styles.details_time}>
                            <div style={{ marginTop: 4 }}>
                              <DateFormat endTime={campData?.batchInfo.enTime} endText="后结束" />
                            </div>
                          </div>
                        )}
                        {studentInfo?.campStudyState === CampStudyState.NOT_START_LEARNING && (
                          <div className={styles.details_time}>
                            <div style={{ marginTop: 4 }}>
                              <DateFormat endTime={campData?.batchInfo.stTime} endText="后开始" />
                            </div>
                          </div>
                        )}
                      </div>
                      <a
                        className={cx(styles.details_btn, 'com_camp_btn')}
                        href={`/v2/camp/class/${studentInfo.batchId}`}
                      >
                        进入打卡营
                      </a>
                    </div>
                  ) : !campData?.signUp ? (
                    <div className={cx(styles.details_btn_box, 'flex_3')}>
                      <div>
                        <div className="f20 fw600">{campData?.name}</div>
                        <div className={styles.details_time}>
                          {entryBatch && (
                            <div style={{ marginTop: 4 }}>
                              <DateFormat endTime={entryBatch?.stTime} startText="报名截止：" />
                            </div>
                          )}
                        </div>
                      </div>
                      <a
                        className={cx(styles.details_btn, 'com_camp_btn_orange')}
                        onClick={() => {
                          // 判断是否登录
                          if (!initialState?.uid) {
                            loginCas({
                              env: process.env.UMI_ENV === 'product' ? 'prod' : 'test',
                              redirectUrl: location.search
                                ? `${location.pathname}${location.search}&entryForm=true`
                                : `${location.pathname}?entryForm=true`,
                            });
                          } else {
                            if (campData.studentCampSuccess) {
                              Modal.confirm({
                                icon: <InfoCircleOutlined style={{ color: '#0082fc' }} />,
                                title: '已经学习过此打卡营了',
                                content: (
                                  <div>
                                    点击这里
                                    <a
                                      href={`/v2/camp/class/${campData.studentCampSuccess?.batchId}`}
                                      target="_blank"
                                      className="col008"
                                    >
                                      查看打卡成功记录
                                    </a>
                                  </div>
                                ),
                                onCancel: () => {
                                  window.location.href = '/v2/camp';
                                },
                                centered: true,
                                okText: '我知道了',
                                cancelText: '查看更多打卡营',
                                autoFocusButton: null,
                              });
                            } else {
                              setOpen(true);
                            }
                          }
                        }}
                      >
                        立即报名
                      </a>
                    </div>
                  ) : (
                    <div className="flex_3">
                      <div></div>
                      <Button
                        style={{ width: 160, height: 40, color: '#666' }}
                        type="default"
                        disabled
                      >
                        暂无开班计划
                      </Button>
                    </div>
                  )}
                </div>
              )}
              {isStudentInfo && !campData?.batchInfo && (
                <div className="flex_3">
                  <div className="flex_2">
                    <div className="f20 fw600">{campData?.name}</div>
                  </div>
                  <Button style={{ width: 160, height: 40 }} type="default" disabled>
                    {classBatchId ? '已结束报名' : '暂无开班计划'}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {campData && (campData.nextBatchInfo || campData.batchInfo) && (
        <EntryFormModal
          batch={{ ...entryBatch }}
          campName={campData?.name}
          open={open}
          setOpen={setOpen}
        />
      )}

      <EventTracking />
    </>
  );
}
